export interface OfflineQueueAction {
  clientId: string;
  type: string;
  payload?: unknown;
  enqueuedAt: number;
}

export interface FlushResult {
  clientId: string;
  type: string;
  ok: boolean;
  play?: Record<string, unknown>;
  error?: string;
  /** Business reject — drop from queue (do not retry). */
  terminal?: boolean;
  rejectKey?: string;
}

export const OFFLINE_QUEUE_KEY = 'la_bolita_offline_queue';

export function readOfflineQueue(): OfflineQueueAction[] {
  try {
    const raw = localStorage.getItem(OFFLINE_QUEUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writeOfflineQueue(actions: OfflineQueueAction[]): void {
  if (actions.length === 0) {
    localStorage.removeItem(OFFLINE_QUEUE_KEY);
    return;
  }
  localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(actions));
}

/**
 * Keep actions that failed or have no matching flush result.
 * Callers should normalize a void flush into all-ok results before calling.
 */
export function retainFailedQueueActions(
  pending: OfflineQueueAction[],
  results: FlushResult[],
): OfflineQueueAction[] {
  const byId = new Map(results.map((r) => [r.clientId, r]));
  return pending.filter((action) => {
    const result = byId.get(action.clientId);
    if (!result) return true;
    if (result.terminal) return false;
    return result.ok === false;
  });
}
